/**
 * Converts a string to sentence case (first letter capitalized, rest lowercase)
 * @param str - The string to convert
 * @returns The string in sentence case
 */
export const toSentenceCase = (str: string): string => {
  if (!str || typeof str !== 'string') {
    return '';
  }
  
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

/**
 * Converts a string to title case (first letter of each word capitalized)
 * @param str - The string to convert
 * @returns The string in title case
 */
export const toTitleCase = (str: string): string => {
  if (!str || typeof str !== 'string') {
    return '';
  }
  
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.toUpperCase() === 'N/A' ? 'N/A' : word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Capitalizes the first letter of a string without changing the rest
 * @param str - The string to capitalize
 * @returns The string with first letter capitalized
 */
export const capitalizeFirst = (str: string): string => {
  if (!str || typeof str !== 'string') {
    return '';
  }
  
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Converts kebab-case or snake_case to sentence case
 * @param str - The string to convert (e.g., "hello-world" or "hello_world")
 * @returns The string in sentence case (e.g., "Hello world")
 */
export const kebabToSentenceCase = (str: string): string => {
  if (!str || typeof str !== 'string') {
    return '';
  }
  
  return str
    .replace(/[-_]/g, ' ')
    .split(' ')
    .map((word, index) => 
      index === 0 
        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        : word.toLowerCase()
    )
    .join(' ');
};
